import React, { Component, createRef } from "react";
import { addDays, differenceInCalendarDays, format } from "date-fns";

import commonFunction from "../../../../lib/utils/common";
import DesktopCalender from "../../../calendar/flightCalender/theme2/modifySearch/ModifyDesktopCalender";
import FlightAutoComplete from "./FlightAutoComplete";
import EconomyPopup from "./EconomyPopup";

const cabinClass = [
  { id: 1, value: "Economy", label: "Economy" },
  { id: 2, value: "Business", label: "Business" },
  { id: 3, value: "First Class", label: "First Class" },
  { id: 4, value: "Premium Economy", label: "Premium Economy" },
];

const todaysDate = format(new Date(), "dd-LLL-yyyy");
let search_type = "";
class ModifySearch extends Component {
  constructor(props) {
    super(props);
    this.travellerDivRef = createRef();
    this.economyPopUpWrapper = createRef();
    this.departureListWrapper = createRef();
    this.returnListWrapper = createRef();
    let returnDate = format(
      addDays(new Date(props?.queryParams?.departure), 7),
      "dd-LLL-yyyy"
    );
    if (props?.queryParams?.arrival) {
      let dayDifference = differenceInCalendarDays(
        new Date(props?.queryParams?.arrival),
        new Date(props?.queryParams?.departure)
      );
      if (dayDifference >= 0) {
        //     returnDate = format(addDays(new Date(props?.queryParams?.departure), 7), 'dd-LLL-yyyy')
        // } else {
        returnDate = format(
          new Date(props?.queryParams?.arrival),
          "dd-LLL-yyyy"
        );
      }
    }
    this.state = {
      departureDate: props?.queryParams?.departure
        ? format(new Date(props?.queryParams?.departure), "dd-LLL-yyyy")
        : format(new Date(), "dd-LLL-yyyy"),
      returnDate: returnDate,
      expandDepartureDateBoolean: false,
      expandReturnDateBoolean: false,
      isOnewaySearch: !props?.queryParams?.arrival,
      departureValue: props?.queryParams?.fromCity
        ? `${props?.queryParams?.fromCity} `
        : "",
      goingToValue: props?.queryParams?.toCity
        ? `${props?.queryParams?.toCity} `
        : "",
      expandDepartureBoolean: false,
      expandGoingToBoolean: false,
      paxAdultValue: +props?.queryParams?.adults,
      paxChildrenValue: +props?.queryParams?.child,
      paxInfantValue: +props?.queryParams?.infants,
      SelectedClassValue: cabinClass.find(
        (cls) => cls.id == props?.queryParams?.class
      ),
      SelectedClassValueTwo: cabinClass.find(
        (cls) => cls.id == props?.queryParams?.returnclass
      ),
      openCabinClassList: false,
      getDepartureSuggestionList: this.props.homeData,
      getGoingToSuggestionList: this.props.homeData,
      departureAirportCode: props?.queryParams?.from,
      goingToAirportCode: props?.queryParams?.to,
      isError: {
        departure: false,
        goingTo: false,
        departureDate: false,
        goingToDate: false,
      },
      returnCity: props?.queryParams?.toCity || "",
      departureCity: props?.queryParams?.fromCity || "",
      isTravelersPopupVisible: false,
      travellersObjOrigin: {
        adults: +props?.queryParams?.adults,
        child: +props?.queryParams?.child,
        infants: +props?.queryParams?.infants,
        originalSelectedClass: cabinClass.find(
          (cls) => cls.id == props?.queryParams?.class
        ),
      },
      code: "",
      name: "",
      airportName: "",
      indexDropdown: -1,
      goingToAirPortName: props.queryParams.goingToAirPortName,
      departureAirPortName: props.queryParams.departureAirPortName,
      openCabinClassListOne: false,
      openCabinClassListTwo: false,
      isCalenderVisible: false

    };
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside, false);
    document.addEventListener("keydown", this.handleTabInside);
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside, false);
    document.removeEventListener("keydown", this.handleTabInside);
  }

  handleClickOutside = (event) => {
    if (
      this.travellerDivRef.current &&
      !this.travellerDivRef.current.contains(event.target)
    ) {
      this.setState({
        isTravelersPopupVisible: false,
        openCabinClassList: false,
        paxAdultValue: this.state.travellersObjOrigin.adults,
        paxChildrenValue: this.state.travellersObjOrigin.child,
        paxInfantValue: this.state.travellersObjOrigin.infants,
      });
    }
    if (
      this.economyPopUpWrapper.current &&
      !this.economyPopUpWrapper.current.contains(event.target)
    ) {
      this.setState({
        openCabinClassList: false,
        SelectedClassValue: {
          ...this.state.travellersObjOrigin.originalSelectedClass,
        },
      });
    }
    if (
      this.departureListWrapper.current &&
      !this.departureListWrapper.current.contains(event.target)
    ) {
      this.setState({ expandDepartureBoolean: false });
    }
    if (
      this.returnListWrapper.current &&
      !this.returnListWrapper.current.contains(event.target)
    ) {
      this.setState({ expandGoingToBoolean: false });
    }
  };

  handleTabInside = (e) => {
    if (e.key !== "Tab") {
      return;
    }
    this.handleClickOutside(e);
  };

  onChangeSetDepartureGoingToValue = (value, type) => {
    if (type === "departure") {
      this.setState({ departureValue: value, departureAirportCode: "" }, () => {
        if (this.state.isError.departure === true) {
          this.validateErrorMsg();
        }
        if (value.length === 0) {
          this.setState({ getDepartureSuggestionList: [] });
        }
      });
    } else {
      this.setState({ goingToValue: value, goingToAirportCode: "" }, () => {
        if (this.state.isError.goingTo === true) {
          this.validateErrorMsg();
          if (value.length === 0)
            this.setState({ getGoingToSuggestionList: [] });
        }
      });
    }

    if (type === "departure") {
      this.props.getAutoSuggestData(value, type, "change");
      this.setState({ expandDepartureBoolean: true });
    } else {
      this.props.getAutoSuggestData(value, type, "change");
      this.setState({ expandGoingToBoolean: true });
    }
  };

  onchangeVisibility = (bool, type) => {
    // if (type === "goingTo") {
    //   this.setState(
    //     { expandReturnDateBoolean: bool, expandDepartureDateBoolean: false },
    //     () => {
    //       if (this.state.isOnewaySearch === true) {
    //         this.setState({ isOnewaySearch: false });
    //       }
    //     }
    //   );
    // } else {
    //   this.setState({
    //     expandReturnDateBoolean: false,
    //     expandDepartureDateBoolean: bool,
    //   });
    // }

    this.setState({
      isCalenderVisible: bool
    }, () => {
      if (type == "return") {
        if (this.state.isOnewaySearch === true) {
          this.setState({ isOnewaySearch: false });
        }
      }
    })
  };

  validateErrorMsg = () => {
    const mapDispatch = {
      departure: commonFunction.isValueEmpty(this.state.departureValue)
        ? true
        : false,
      goingTo: commonFunction.isValueEmpty(this.state.goingToValue)
        ? true
        : this.state.departureValue === this.state.goingToValue
          ? true
          : false,
      departureDate: commonFunction.isValueEmpty(this.state.departureDate)
        ? true
        : false,
      goingToDate: commonFunction.isValueEmpty(this.state.returnDate)
        ? true
        : false,
    };
    this.setState({ isError: mapDispatch });
  };

  onClickSetDepartureGoingToValue = (city, airPortCode, airPortName, type) => {
    if (type === "departure") {
      this.setState(
        {
          departureValue: city,
          departureAirPortName: airPortCode + " - " + airPortName + " ",
          departureAirportCode: airPortCode,
          departureCity: city,
        },
        () => {
          if (this.state.isError.departure === true) {
            this.validateErrorMsg();
          }
        }
      );
    } else {
      this.setState(
        {
          goingToValue: city,
          goingToAirPortName: airPortCode + " - " + airPortName + " ",
          goingToAirportCode: airPortCode,
          returnCity: city,
        },
        () => {
          if (this.state.isError.goingTo === true) {
            this.validateErrorMsg();
          }
        }
      );
    }
  };

  onClickSwap = () => {
    if (this.state.departureValue || this.state.goingToValue) {
      let departureValue = this.state.departureValue;
      let departureAirportCode = this.state.departureAirportCode;
      let departureCity = this.state.departureCity;
      let departureAirPortName = this.state.departureAirPortName;
      this.setState({
        departureValue: this.state.goingToValue,
        goingToValue: departureValue,
        departureAirportCode: this.state.goingToAirportCode,
        goingToAirportCode: departureAirportCode,
        departureCity: this.state.returnCity,
        returnCity: departureCity,
        departureAirPortName: this.state.goingToAirPortName,
        goingToAirPortName: departureAirPortName,
      });
    }
  };
  onChangeDepartureGoingDateValue = (value, type) => {
    console.log("typeaabcd", type, value);

    if (type === "endDate") {
      let dayDifference = differenceInCalendarDays(
        new Date(value),
        new Date(this.state.departureDate)
      );
      if (value) {
        if (dayDifference < 0) {
          // this.setState({
          //   isOnewaySearch: true,
          //   returnDate: format(addDays(new Date(), 7), "dd-LLL-yyyy"),
          // });
        } else {
          this.setState(
            { returnDate: format(new Date(value), "dd-LLL-yyyy") },
            () => {
              console.log("this.state.returnDate", this.state.returnDate);
            }
          );
        }
      }
    } else {
      if (value) {
        let returnDate = this.state.returnDate;
        let dayDifference = differenceInCalendarDays(
          new Date(this.state.returnDate),
          new Date(value)
        );
        if (/* this.state.isOnewaySearch && */ dayDifference < 0) {
          returnDate = format(addDays(new Date(value), 7), "dd-LLL-yyyy");
        }
        this.setState(
          { departureDate: format(new Date(value), "dd-LLL-yyyy"), returnDate },
          () => {
            console.log("this.state.departureDate", this.state.departureDate);
          }
        );
      }
    }
  };

  onclickFlightAutoComplete(type) {
    if (type === "departure") {
      this.setState({ departureValue: "" }, () => {
        this.props.getAutoSuggestData(this.state.departureValue, type, "click");
      });
    } else {
      this.setState({ goingToValue: "" }, () => {
        this.props.getAutoSuggestData(this.state.goingToValue, type, "click");
      });
    }
  }

  onTravellersClickHandler = () => {
    this.setState({ isTravelersPopupVisible: true });
  };

  onClickChangePaxNumber = (pax, value, type) => {
    if (pax === "adult") {
      if (
        +value > 0 &&
        +this.state.paxChildrenValue + value <= 9 &&
        +this.state.paxChildrenValue + value > 0
      ) {
        this.setState({ paxAdultValue: value }, () => {
          if (type === "minus") {
            if (+this.state.paxInfantValue > value) {
              let paxInfantValue = +this.state.paxInfantValue;
              this.setState({ paxInfantValue: paxInfantValue - 1 });
            }
          }
        });
      }
    } else if (pax === "children") {
      if (
        +value + +this.state.paxAdultValue <= 9 &&
        +value + +this.state.paxAdultValue > 0
      ) {
        this.setState({ paxChildrenValue: +value });
      } else if (+value + this.state.paxAdultValue > 9 && type === "minus") {
        this.setState({ paxChildrenValue: 9 - this.state.paxAdultValue });
      }
    } else if (pax === "infant") {
      // if (value > (+this.state.paxAdultValue)) {
      //     this.setState({ paxInfantValue: +(--value) });
      // } else {
      //     this.setState({ paxInfantValue: +value });
      // }
      if (+value >= 0 && +value <= this.state.paxAdultValue) {
        this.setState({ paxInfantValue: +value });
      } else if (+value > this.state.paxAdultValue && type === "minus") {
        this.setState({ paxInfantValue: +this.state.paxAdultValue });
      }
    }
  };

  onClickSearchFlight = () => {
    console.log('onClickSearchFlight: ',this.state.departureValue,this.state.goingToValue);
    const mapDispatch = {
      departure: commonFunction.isValueEmpty(this.state.departureValue)
        ? true
        : !this.state.departureAirportCode
          ? true
          : false,
      goingTo: commonFunction.isValueEmpty(this.state.goingToValue)
        ? true
        : !this.state.goingToAirportCode
          ? true
          : this.state.departureValue.trim() === this.state.goingToValue.trim()
            ? true
            : false,
      departureDate: commonFunction.isValueEmpty(this.state.departureDate)
        ? true
        : false,
      goingToDate: commonFunction.isValueEmpty(this.state.returnDate)
        ? true
        : false,
    };
    // console.log("departureValue:", typeof this.state.departureValue);
    // console.log("goingToValue:", typeof this.state.goingToValue);
    // console.log("Comparison result:", this.state.departureValue.trim() === this.state.goingToValue.trim());
    // console.log("mapDispatch", mapDispatch);
    this.setState({ isError: mapDispatch }, () => {
      console.log('isError: ', this.state.isError);
      let Validate = true;
      for (const [key, value] of Object.entries(this.state.isError)) {
        console.log('value: ', value);
        if (value === true) {
          Validate = false;
          break;
        }
      }
      let arrivalDate = "";
      let departureDateArr = !commonFunction.isValueEmpty(
        this.state.departureDate
      )
        ? this.state.departureDate.split("/")
        : "";
      let departureDate = !commonFunction.isValueEmpty(departureDateArr)
        ? format(new Date(this.state.departureDate), "yyyy-MM-dd")
        : "";
      if (this.state.isOnewaySearch === false) {
        let arrivalDateArr = !commonFunction.isValueEmpty(this.state.returnDate)
          ? this.state.returnDate.split("/")
          : "";
        arrivalDate = !commonFunction.isValueEmpty(arrivalDateArr)
          ? format(new Date(this.state.returnDate), "yyyy-MM-dd")
          : "";
      }
      let urlQuery = {
        from: this.state.departureAirportCode,
        to: this.state.goingToAirportCode,
        type: 1,
        class: this.state.SelectedClassValue.id,
        adults: this.state.paxAdultValue,
        child: this.state.paxChildrenValue,
        infants: this.state.paxInfantValue,
        departure: departureDate,
        arrival: arrivalDate,
        fromCity: this.state.departureCity,
        toCity: this.state.returnCity,
        departureAirPortName: this.state.departureAirPortName,
        goingToAirPortName: this.state.goingToAirPortName,
      };
      if (Validate === true)
        commonFunction.redirectTo("flight/search", urlQuery);
    });
  };

  onDoneBtnClickHandler = () => {
    this.setState({
      travellersObjOrigin: {
        adults: this.state.paxAdultValue,
        child: this.state.paxChildrenValue,
        infants: this.state.paxInfantValue,
        originalSelectedClass: {
          ...this.state.SelectedClassValue,
        },
      },
      isTravelersPopupVisible: false,
    });
  };

  onClickOpenCabinClassList = () => {
    if (this.state.openCabinClassList === false) {
      this.setState({ openCabinClassList: true });
    } else if (this.state.openCabinClassList === true) {
      this.setState({ openCabinClassList: false });
    }
  };

  // onClickSwap = () => {
  //     if (!commonFunction.isValueEmpty(this.state.departureValue) && !commonFunction.isValueEmpty(this.state.goingToValue)) {
  //         this.setState({ departureValue: this.state.goingToValue, goingToValue: this.state.departureValue });
  //     }
  // }

  cabinClassSelectHandler = (element) => {
    this.setState({
      SelectedClassValue: { label: element.label, id: element.id },
      openCabinClassList: false,
    });
  };

  deleteReturnDateHandler = () => {
    console.log("deleteReturnDateHandler");
    this.setState({ isOnewaySearch: true, expandReturnDateBoolean: false });
  };

  removeReturnDateHandler = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    this.deleteReturnDateHandler();
  };

  highlightData(id, parentElement) {
    let innerContent = document.getElementById(parentElement).children;
    for (let i = 0; i < innerContent.length; i++) {
      let selectedElement = innerContent[i];
      selectedElement.style.backgroundColor = i == id ? "#ccc" : "#fff";
    }
    innerContent[id].scrollIntoView({
      behavior: "smooth",
      block: "nearest",
      inline: "start",
    });
  }

  onKeyDownArrow = (event, parentClassId, list, type) => {
    let code = "";
    let name = "";
    let airportName = "";
    let indexDropdown = this.state.indexDropdown;
    switch (event.which) {
      case 38: // up
        indexDropdown--;
        if (indexDropdown < 0) {
          indexDropdown = 0;
        }
        this.highlightData(indexDropdown, parentClassId);
        code =
          list.length >= indexDropdown
            ? `${list[indexDropdown].AIRPORT_CODE}`
            : "";
        name =
          list.length >= indexDropdown
            ? `${list[indexDropdown].CITY_NAME}`
            : "";
        airportName =
          list.length >= indexDropdown
            ? `${list[indexDropdown].AIRPORT_NAME}`
            : "";
        search_type =
          list.length >= indexDropdown
            ? `${list[indexDropdown].search_type
              ? list[indexDropdown].search_type
              : 1
            }`
            : "";
        break;
      case 40: // down
        indexDropdown++;
        if (indexDropdown >= list.length - 1) {
          indexDropdown = list.length - 1;
        }
        this.highlightData(indexDropdown, parentClassId);
        code =
          list.length >= indexDropdown
            ? `${list[indexDropdown].AIRPORT_CODE}`
            : "";
        name =
          list.length >= indexDropdown
            ? `${list[indexDropdown].CITY_NAME}`
            : "";
        airportName =
          list.length >= indexDropdown
            ? `${list[indexDropdown].AIRPORT_NAME}`
            : "";
        search_type =
          list.length >= indexDropdown
            ? `${list[indexDropdown].search_type
              ? list[indexDropdown].search_type
              : 1
            }`
            : "";
        break;

      case 13: //enter
        if (this.state.code && this.state.name) {
          this.onClickSetDepartureGoingToValue(
            this.state.name,
            this.state.code,
            this.state.airportName,
            type
          );
        }
        if (type === "departure") {
          this.setState({ expandDepartureBoolean: false });
        }
        if (type === "goingTo") {
          this.setState({ expandGoingToBoolean: false });
        }
        indexDropdown = -1;
        break;
      case 9: //enter
        if (this.state.code && this.state.name) {
          this.onClickSetDepartureGoingToValue(
            this.state.name,
            this.state.code,
            this.state.airportName,
            type
          );
        }
        if (type === "departure") {
          this.setState({ expandDepartureBoolean: false });
        }
        if (type === "goingTo") {
          this.setState({ expandGoingToBoolean: false });
        }
        indexDropdown = -1;
        break;
      default:
    }
    this.setState({
      code: code,
      name: name,
      airportName: airportName,
      indexDropdown: indexDropdown,
    });
  };

  modifySearchKeyDownHandler = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    this.onClickSearchFlight();
  };

  onSwapKeyDownHandler = (e) => {
    if (e.key !== "Enter") {
      return;
    }
    this.onClickSwap();
  };

  onClickOpenCabinClassListOne = () => {
    if (this.state.openCabinClassListOne === false) {
      this.setState({ openCabinClassListOne: true });
    } else if (this.state.openCabinClassListOne === true) {
      this.setState({ openCabinClassListOne: false });
    }
  };

  onClickOpenCabinClassListTwo = () => {
    if (this.state.openCabinClassListTwo === false) {
      this.setState({ openCabinClassListTwo: true });
    } else if (this.state.openCabinClassListTwo === true) {
      this.setState({ openCabinClassListTwo: false });
    }
  };

  render() {
    console.log("this.prop", this.props);
    return (
      <div className="flex flex-row w-full mx-auto gray_color newcontainer">
        <div className={this.props.styles.flightsearchpage_widget}>
          <div class={this.props.styles.flight_way_tab}>
            <div class={this.props.styles.flight_way_btngrp}>
              <button
                className={
                  this.state.isOnewaySearch
                    ? this.props.styles.active_way
                    : this.props.styles.button_style
                }
                onClick={() => {
                  this.setState({
                    isOnewaySearch: true,
                    expandGoingToDateBoolean: false,
                    expandDepartureDateBoolean: false,
                  });
                }}
              >
                One-Way
              </button>
              <button
                className={
                  this.state.isOnewaySearch === false
                    ? this.props.styles.active_way
                    : this.props.styles.button_style
                }
                onClick={() => {
                  this.setState({
                    isOnewaySearch: false,
                    goingToDateValue: commonFunction.getDateWithFormat(
                      addDays(new Date(this.state.departureDateValue), 7),
                      this?.props?.dateFormat
                    ),
                  });
                }}
              >
                Round-Way
              </button>
            </div>
          </div>
          <div className={this.props.styles.flightsearchpage_widget_flex}>
            <div className={this.props.styles.flightautocomplete_main}>
              <FlightAutoComplete
                leftIcon={
                  <svg
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    enable-background="new 0 0 30 30"
                  >
                    <g
                      id="Group_1400"
                      data-name="Group 1400"
                      transform="translate(-9574.354 -279.94)"
                    >
                      <path
                        id="Path_726"
                        data-name="Path 726"
                        d="M88.156,98.443l13.937-4.429a1.536,1.536,0,0,0,1-.975,1.647,1.647,0,0,0-.528-1.767,3.682,3.682,0,0,0-3.738-.67l-3.251,1.239L91.1,89.078a.374.374,0,0,0-.325-.041l-1.93.61a.392.392,0,0,0-.163.65L91.671,93.3l-4.124,1.564L85.8,93.73a.374.374,0,0,0-.325-.041l-1.32.427a.4.4,0,0,0-.2.589L86.1,97.753a1.821,1.821,0,0,0,2.052.691Z"
                        transform="translate(9490.469 190.924)"
                        fill="#616161"
                      ></path>
                      <path
                        id="Path_727"
                        data-name="Path 727"
                        d="M121.631,412.16H105.215a1.056,1.056,0,1,0,0,2.113h16.415a1.056,1.056,0,1,0,0-2.113Z"
                        transform="translate(9470.931 -120.497)"
                        fill="#616161"
                      ></path>
                    </g>
                  </svg>
                }
                label="Origin"
                value={this.state.departureValue}
                styles={this.props.styles}
                onclickFlightAutoComplete={() =>
                  this.onclickFlightAutoComplete("departure")
                }
                placholder="Origin"
                onClickSourceAndDestination={(city, airPortCode, airPortName) =>
                  this.onClickSetDepartureGoingToValue(
                    city,
                    airPortCode,
                    airPortName,
                    "departure"
                  )
                }
                onChangeSourceAndDestination={(value) =>
                  this.onChangeSetDepartureGoingToValue(value, "departure")
                }
                isAutoCompleteExpand={(bool) =>
                  this.setState({ expandDepartureBoolean: bool })
                }
                autoCompleteData={
                  !commonFunction.isValueEmpty(
                    this.props.getDepartureSuggestionList
                  )
                    ? this.props.getDepartureSuggestionList
                    : []
                }
                expandAutoCompleteBool={
                  !commonFunction.isValueEmpty(
                    this.state.expandDepartureBoolean
                  )
                    ? this.state.expandDepartureBoolean
                    : false
                }
                errorMessage={"Please select your Origin City"}
                isError={this.state.isError.departure}
                listWrapper={this.departureListWrapper}
                onKeyDownArrow={(event) => {
                  this.onKeyDownArrow(
                    event,
                    "flightDataArray",
                    this.props.getDepartureSuggestionList,
                    "departure"
                  );
                }}
                airPortName={this.state.departureAirPortName}
              />
              <span
                className={this.props.styles.flight_swap}
                tabIndex="2"
                onKeyDown={this.onSwapKeyDownHandler}
                onClick={this.onClickSwap}
              >
                <svg
                  version="1.1"
                  id="Layer_1"
                  x="0px"
                  y="0px"
                  width="30px"
                  height="30px"
                  viewBox="0 0 30 30"
                  enableBackground="new 0 0 30 30"
                >
                  <g
                    id="Group_1402"
                    data-name="Group 1402"
                    transform="translate(-200.5 -195.5)"
                  >
                    <rect
                      id="Rectangle_9"
                      data-name="Rectangle 9"
                      width="28"
                      height="28"
                      rx="8"
                      transform="translate(201 196)"
                      fill="#fff"
                      stroke="#e72643"
                      stroke-width="1"
                    />
                    <path
                      id="Path_90"
                      data-name="Path 90"
                      d="M543.9,906.055h15.23l-4.035-4.494"
                      transform="translate(-336.163 -697.263)"
                      fill="none"
                      stroke="#707070"
                      stroke-width="1"
                    />
                    <path
                      id="Path_91"
                      data-name="Path 91"
                      d="M0,4.494H15.23L11.194,0"
                      transform="translate(222.97 215.702) rotate(180)"
                      fill="none"
                      stroke="#707070"
                      stroke-width="1"
                    />
                  </g>
                </svg>
              </span>
              <div className={this.props.styles.flight_ptext}>
                {/* <p>DXB - Dubai International Airport</p> */}
              </div>
            </div>

            <div className={this.props.styles.flightautocomplete_main}>
              <FlightAutoComplete
                leftIcon={
                  <svg
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    enable-background="new 0 0 30 30"
                  >
                    <g
                      id="Group_1401"
                      data-name="Group 1401"
                      transform="translate(-245.5 -158.334)"
                    >
                      <g
                        id="Group_660"
                        data-name="Group 660"
                        transform="translate(-9327.768 -116.501)"
                      >
                        <path
                          id="Path_726"
                          data-name="Path 726"
                          d="M88.156,98.443l13.937-4.429a1.536,1.536,0,0,0,1-.975,1.647,1.647,0,0,0-.528-1.767,3.682,3.682,0,0,0-3.738-.67l-3.251,1.239L91.1,89.078a.374.374,0,0,0-.325-.041l-1.93.61a.392.392,0,0,0-.163.65L91.671,93.3l-4.124,1.564L85.8,93.73a.374.374,0,0,0-.325-.041l-1.32.427a.4.4,0,0,0-.2.589L86.1,97.753a1.821,1.821,0,0,0,2.052.691Z"
                          transform="translate(9549.887 155.802) rotate(30)"
                          fill="#616161"
                        ></path>
                        <path
                          id="Path_727"
                          data-name="Path 727"
                          d="M121.631,412.16H105.215a1.056,1.056,0,1,0,0,2.113h16.415a1.056,1.056,0,1,0,0-2.113Z"
                          transform="translate(9470.931 -120.497)"
                          fill="#616161"
                        ></path>
                      </g>
                    </g>
                  </svg>
                }
                label="Destination"
                value={this.state.goingToValue}
                styles={this.props.styles}
                onclickFlightAutoComplete={() =>
                  this.onclickFlightAutoComplete("goingTo")
                }
                placholder="Destination"
                onClickSourceAndDestination={(city, airPortCode, airPortName) =>
                  this.onClickSetDepartureGoingToValue(
                    city,
                    airPortCode,
                    airPortName,
                    "goingTo"
                  )
                }
                onChangeSourceAndDestination={(value) =>
                  this.onChangeSetDepartureGoingToValue(value, "goingTo")
                }
                isAutoCompleteExpand={(bool) =>
                  this.setState({ expandGoingToBoolean: bool })
                }
                autoCompleteData={
                  !commonFunction.isValueEmpty(
                    this.props.getGoingToSuggestionList
                  )
                    ? this.props.getGoingToSuggestionList
                    : []
                }
                expandAutoCompleteBool={this.state.expandGoingToBoolean}
                errorMessage={
                  this.state.departureValue.trim() === this.state.goingToValue.trim()
                    ? "Origin and destination cannot be same"
                    : "Please select your Destination City"
                }
                isError={this.state.isError.goingTo}
                listWrapper={this.returnListWrapper}
                onKeyDownArrow={(event) => {
                  this.onKeyDownArrow(
                    event,
                    "flightDataArray",
                    this.props.getGoingToSuggestionList,
                    "goingTo"
                  );
                }}
                airPortName={this.state.goingToAirPortName}
              />
              <div className={this.props.styles.flight_ptext}>
                {/* <p>DXB - Dubai International Airport</p> */}
              </div>
            </div>

            <div className={this.props.styles.flightautocompletecalender}>
              <div className={this.props.styles.hightAdj}>


                {/* newcalender */}


                <DesktopCalender
                  styles={this.props.calendarStyles}
                  value={
                    !commonFunction.isValueEmpty(this.state.departureDate)
                      ? this.state.departureDate
                      : ""
                  }
                  departureValue={
                    !commonFunction.isValueEmpty(this.state.departureDate)
                      ? this.state.departureDate
                      : ""
                  }

                  returnValue={
                    !commonFunction.isValueEmpty(this.state.returnDate)
                      ? this.state.returnDate
                      : ""
                  }
                  departureDate={this.state.departureDate}

                  onChangeDate={(value, type) => {
                    this.onChangeDepartureGoingDateValue(
                      value,
                      type
                    );
                  }}

                  iconImage={
                    <svg
                      version="1.1"
                      id="Layer_1"
                      x="0px"
                      y="0px"
                      width="35px"
                      height="35px"
                      viewBox="0 0 35 35"
                      enableBackground="new 0 0 35 35"
                    >
                      <g id="Group_741" data-name="Group 741" transform="translate(-1010 -888.5)">
                        <path id="calendar_icn" d="M28.583,0H3.707A3.6,3.6,0,0,0,0,3.744V28.7a3.63,3.63,0,0,0,3.707,3.8H28.583A3.818,3.818,0,0,0,32.5,28.7V3.744A3.749,3.749,0,0,0,28.583,0ZM3.707,1.354H28.583a2.426,2.426,0,0,1,2.562,2.39V9.479H1.354V3.744A2.245,2.245,0,0,1,3.707,1.354Zm9.835,18.958V16.25h5.417v4.063Zm5.417,1.354v4.062H13.542V21.667Zm-6.771-1.354H6.771V16.25h5.417Zm8.125-4.063h5.416v4.063H20.312Zm0-1.354V10.834h5.416V14.9Zm-1.354,0H13.542V10.834h5.417Zm-6.771,0H6.771V10.834h5.417Zm-6.771,0H1.354V10.834H5.417Zm0,1.354v4.063H1.354V16.25Zm0,5.417v4.062H1.354V21.667Zm1.354,0h5.417v4.062H6.771Zm5.417,5.417v4.063H6.771V27.083Zm1.354,0h5.417v4.063H13.542Zm6.771,0h5.416v4.063H20.312Zm0-1.354V21.667h5.416v4.062Zm6.771-4.062h4.063v4.062H27.083Zm0-1.354V16.25h4.063v4.063Zm0-5.417V10.834h4.063V14.9ZM1.354,28.7V27.083H5.417v4.063H3.707A2.3,2.3,0,0,1,1.354,28.7Zm27.229,2.445h-1.5V27.083h4.063V28.7A2.45,2.45,0,0,1,28.583,31.146Z" transform="translate(1010 888.5)" fill="#3479c5" />
                        <path id="Rectangle_22" data-name="Rectangle 22" d="M3,0H29a3,3,0,0,1,3,3V15a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3A3,3,0,0,1,3,0Z" transform="translate(1010 889)" fill="#3479c5" />
                        <path id="Path_161" data-name="Path 161" d="M14.3,0H0" transform="translate(1032.78 897.708) rotate(180)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1" />
                        <path id="Path_163" data-name="Path 163" d="M2.475,0,0,2.715,2.475,5.19h0" transform="translate(1033.864 900.303) rotate(180)" fill="none" stroke="#fff" stroke-linecap="round" stroke-width="1" />
                      </g>
                    </svg>
                  }
                  startDate={
                    !commonFunction.isValueEmpty(this.state.departureDate)
                      ? this.state.departureDate
                      : ""
                  }
                  endDate={
                    !commonFunction.isValueEmpty(this.state.returnDate)
                      ? this.state.returnDate
                      : ""
                  }
                  startDateLimit={
                    !commonFunction.isValueEmpty(todaysDate)
                      ? todaysDate
                      : ""
                  }
                  dateFormat={this.props.dateFormat}
                  changeVisibility={(bool, type) =>
                    this.onchangeVisibility(bool, type)
                  }
                  isVisible={this.state.isCalenderVisible}
                  type={"double"}
                  searchType={this.state.isOnewaySearch ? "oneWay" : "roundTrip"}
                  oneWayReturnClick={() => { this.setState({ isOnewaySearch: false, isCalenderVisible: true }) }}
                  roundWayReturnClick={() => { this.setState({ isOnewaySearch: true }) }}
                  showCrossIcon={true}
                />
                {/* new calender end */}

                {/* cabin slection dropdown */}
                <div className={this.props.styles.class_select_flex}>
                  <div
                    className={this.props.styles.flight_cabin_class_cont}
                    onClick={() => this.onClickOpenCabinClassListOne()}
                  >
                    <div className={this.props.styles.flight_cabin_class_name}>
                      {!commonFunction.isValueEmpty(
                        this.state.SelectedClassValue
                      )
                        ? this.state.SelectedClassValue.label
                        : "Economy"}
                    </div>
                    <div
                      className={
                        this.props.styles.flight_cabin_class_arrow_pass_mod
                      }
                    >
                      <svg
                        version="1.1"
                        id="Layer_1"
                        x="0px"
                        y="0px"
                        width="30px"
                        height="30px"
                        viewBox="0 0 30 30"
                        enable-background="new 0 0 30 30"
                      >
                        <path
                          id="Path_1101"
                          data-name="Path 1101"
                          d="M339.293,85.293l1.414,1.414L334,93.414l-6.707-6.707,1.414-1.414L334,90.586Z"
                          transform="translate(-327.293 -85.293)"
                          fill-rule="evenodd"
                        ></path>
                      </svg>
                    </div>
                    {this.state.openCabinClassListOne === true ? (
                      <div
                        ref={this.economydeparturePopUpWrapper}
                        className={this.props.styles.flight_cabin_class_list}
                      >
                        {cabinClass.map((element, index) => {
                          return (
                            <div
                              key={"cabinClass" + index}
                              className={
                                this.props.styles.flight_cabin_class_ele
                              }
                              onClick={() => {
                                this.setState({
                                  SelectedClassValue: {
                                    label: element.label,
                                    id: element.id,
                                  },
                                  openCabinClassListOne: false,
                                });
                              }}
                            >
                              {element.label}
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                  </div>

                  {/* dropdown sellection label */}
                  <div
                    className={this.props.styles.flight_cabin_class_cont}
                    onClick={() => this.onClickOpenCabinClassListOne()}
                  >
                    {/* <div
                className={this.props.styles.flight_cabin_class_cont}
              onClick={() => this.onClickOpenCabinClassListTwo()}
              > */}
                    {!this.state.isOnewaySearch && (
                      <div
                        className={this.props.styles.flight_cabin_class_name}
                      >
                        {!commonFunction.isValueEmpty(
                          this.state.SelectedClassValue
                        )
                          ? this.state.SelectedClassValue.label
                          : "Economy"}
                      </div>
                    )}

                    {/* </div> */}
                  </div>
                </div>
              </div>
            </div>

            {/* by aarti */}
            {/* <div className={this.props.styles.flightautocompletecalender}>
                        <DesktopCalender
                            styles={this.props.styles}
                            value={this.state.isOnewaySearch === false ? !commonFunction.isValueEmpty(this.state.returnDate) ? this.state.returnDate : "" : "Tap to add return"}
                            departureValue={ !commonFunction.isValueEmpty(this.state.departureDate ) ? this.state.departureDate  : ""}
                            returnValue={ !commonFunction.isValueEmpty(this.state.returnDate )  && this.state.returnDate !== "NA" ? this.state.returnDate : "Tap to add return" }
                        
                            placholder=""
                            onChangeDate={(value,type) => { this.onChangeDepartureGoingDateValue(value, type) }}
                            iconImage={
                                <svg version="1.1" id="Layer_1" x="0px" y="0px" width="35px" height="35px" viewBox="0 0 35 35" enable-background="new 0 0 35 35"><g id="Group_741" transform="translate(-1010 -888.5)"><path id="calendar_icn" fill="#3479C5" d="M1038.583,888.5h-24.876c-1.987-0.061-3.647,1.501-3.708,3.488 c-0.002,0.085-0.002,0.17,0.001,0.256V917.2c-0.094,2.003,1.453,3.702,3.455,3.797c0.084,0.004,0.168,0.005,0.252,0.003h24.876 c2.108,0.055,3.86-1.609,3.915-3.718c0.002-0.027,0.002-0.055,0.002-0.082v-24.956c0-2.071-1.68-3.749-3.75-3.748 C1038.694,888.496,1038.639,888.498,1038.583,888.5z M1013.707,889.854h24.876c1.338-0.075,2.483,0.948,2.559,2.286 c0.002,0.035,0.003,0.069,0.003,0.104v5.735h-29.791v-5.735c-0.082-1.237,0.855-2.307,2.092-2.388 C1013.533,889.85,1013.62,889.85,1013.707,889.854z M1023.542,908.813v-4.063h5.417v4.063H1023.542z M1028.959,910.166v4.063 h-5.417v-4.062L1028.959,910.166z M1022.188,908.813h-5.417v-4.063h5.417V908.813z M1030.313,904.749h5.416v4.063h-5.416V904.749z M1030.313,903.395v-4.061h5.416v4.066L1030.313,903.395z M1028.959,903.395h-5.417v-4.061h5.417V903.395z M1022.188,903.395 h-5.417v-4.061h5.417V903.395z M1015.417,903.395h-4.063v-4.061h4.063V903.395z M1015.417,904.749v4.063h-4.063v-4.063 L1015.417,904.749z M1015.417,910.166v4.063h-4.063v-4.062L1015.417,910.166z M1016.771,910.166h5.417v4.063h-5.417V910.166z M1022.188,915.583v4.063h-5.417v-4.063H1022.188z M1023.542,915.583h5.417v4.063h-5.417V915.583z M1030.313,915.583h5.416v4.063 h-5.416V915.583z M1030.313,914.229v-4.062h5.416v4.062H1030.313z M1037.084,910.167h4.063v4.062h-4.063L1037.084,910.167z M1037.084,908.813v-4.063h4.063v4.063H1037.084z M1037.084,903.396v-4.062h4.063v4.066L1037.084,903.396z M1011.354,917.2v-1.617 h4.063v4.063h-1.71c-1.27,0.031-2.325-0.973-2.357-2.242C1011.348,917.336,1011.35,917.268,1011.354,917.2z M1038.583,919.645h-1.5 v-4.062h4.063v1.617c-0.002,1.353-1.099,2.449-2.451,2.448c-0.038,0-0.075-0.001-0.112-0.002V919.645z"></path><path id="Rectangle_22" fill="#3479C5" d="M1013,889h26c1.656,0,3,1.343,3,3v12l0,0h-32l0,0v-12 C1010,890.343,1011.343,889,1013,889z"></path><path id="Path_161" fill="none" stroke="#FFFFFF" stroke-linecap="round" d="M1033.863,897.708h-14.3"></path><path id="Path_163" fill="none" stroke="#FFFFFF" stroke-linecap="round" d="M1020.955,895.113l-2.476,2.715l2.476,2.475l0,0"></path></g></svg>
                              }
                            startDate={!commonFunction.isValueEmpty(this.state.departureDate) ? this.state.departureDate : ""}
                            endDate={!commonFunction.isValueEmpty(this.state.returnDate) ? this.state.returnDate : ""}
                            startDateLimit={!commonFunction.isValueEmpty(this.state.departureDate) ? this.state.departureDate : ""}
                            dateFormat={this.props.dateFormat}
                            changeVisibility={(bool) => this.onchangeVisibility(bool, "goingTo")}
                            isVisible={this.state.expandReturnDateBoolean}
                            type={"double"}
                            doubleSelection={true}
                            theme={'flight_theme2'}
                        />
                        {!this.state.isOnewaySearch && <div style={{ position: "absolute", top: "6px", right:"6px", alignItems: "center", cursor:"pointer" }}>
                            <img src='/images/close-red.svg' tabIndex="2" style={{ width: "15px", height: "15px", right: "0" }} 
                            onKeyDown={this.removeReturnDateHandler} onClick={this.deleteReturnDateHandler}
                             />
                        </div>}
                        <div
                      className={this.props.styles.flight_cabin_class_cont}
                      // onClick={() => this.onClickOpenCabinClassListTwo()}
                    >
                      {!this.state.isOnewaySearch && <div
                        className={this.props.styles.flight_cabin_class_name}
                      >
                        {!commonFunction.isValueEmpty(this.state.SelectedClassValue)
                          ? this.state.SelectedClassValue.label
                          : "Economy"}
                      </div>}
                     
                     
                     
                    </div>
                    </div> */}

            <div className={this.props.styles.flightautocomplemodify}>
              <div className={this.props.styles.flightautocompletetraveller}>
                <div
                  className={this.props.styles.flightfirstdiv}
                  onClick={this.onTravellersClickHandler}
                >
                  <input
                    type={"text"}
                    value={
                      this.state.travellersObjOrigin.adults +
                      this.state.travellersObjOrigin.child +
                      this.state.travellersObjOrigin.infants
                    }
                    readOnly /* tabIndex="2" onClick={this.onTravellersClickHandler} /* onFocusCapture={this.onTravellersClickHandler} */
                  />
                  <label>Passenger</label>
                  <svg
                    version="1.1"
                    id="Layer_1"
                    x="0px"
                    y="0px"
                    width="30px"
                    height="30px"
                    viewBox="0 0 30 30"
                    enableBackground="new 0 0 30 30"
                  >
                    <path
                      id="XMLID_224_"
                      fill="currentColor"
                      d="M1.869,11.074l12.576,12.575c0.236,0.236,0.556,0.368,0.889,0.368
	c0.334,0,0.654-0.132,0.889-0.368l12.576-12.575c0.489-0.492,0.489-1.288,0-1.779c-0.492-0.491-1.288-0.491-1.779,0L15.333,20.98
	L3.647,9.295C3.401,9.049,3.08,8.926,2.757,8.926c-0.322,0-0.643,0.123-0.889,0.369C1.377,9.786,1.377,10.582,1.869,11.074z"
                    />
                  </svg>
                </div>
                {this.state.isTravelersPopupVisible && (
                  <EconomyPopup
                    travellerDivRef={this.travellerDivRef}
                    economyPopUpWrapper={this.economyPopUpWrapper}
                    state={this.state}
                    styles={this.props.styles}
                    cabinClass={cabinClass}
                    cabinClassSelectHandler={this.cabinClassSelectHandler}
                    onClickChangePaxNumber={this.onClickChangePaxNumber}
                    onClickOpenCabinClassList={this.onClickOpenCabinClassList}
                    onDoneBtnClickHandler={this.onDoneBtnClickHandler}
                  />
                )}
              </div>
              <button
                tabIndex="2"
                onClick={this.onClickSearchFlight}
                onKeyDown={this.modifySearchKeyDownHandler}
              >
                Update Search
                <svg width="50px" height="50px" viewBox="0,0,256,256">
                  <g
                    fill="#ffffff"
                    fill-rule="nonzero"
                    stroke="none"
                    stroke-width="1"
                    stroke-linecap="butt"
                    stroke-linejoin="miter"
                    stroke-miterlimit="10"
                    stroke-dasharray=""
                    stroke-dashoffset="0"
                    font-family="none"
                    font-weight="none"
                    font-size="none"
                    text-anchor="none"
                  >
                    <g transform="scale(5.12,5.12)">
                      <path d="M21,3c-9.39844,0 -17,7.60156 -17,17c0,9.39844 7.60156,17 17,17c3.35547,0 6.46094,-0.98437 9.09375,-2.65625l12.28125,12.28125l4.25,-4.25l-12.125,-12.09375c2.17969,-2.85937 3.5,-6.40234 3.5,-10.28125c0,-9.39844 -7.60156,-17 -17,-17zM21,7c7.19922,0 13,5.80078 13,13c0,7.19922 -5.80078,13 -13,13c-7.19922,0 -13,-5.80078 -13,-13c0,-7.19922 5.80078,-13 13,-13z"></path>
                    </g>
                  </g>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ModifySearch;
